import React from 'react';

const PageNotFound = () => {
    return (
        <h1 className="below-header">404: Page not found</h1>
    );
};

export default PageNotFound;